import Vue from 'vue';
import store from '@/store';
import router from '@/router';

// Models
import User from '@/models/User';

// Views
import App from '@/views/App.vue';
import i18n, { loadAllLocales } from '@/entrypoints/i18n';
import AppLayout from '@/layouts/AppLayout.vue';

// Logging
import FrontendLogger from '@/modules/FrontendLogger';

// Vendor
import $ from 'jquery';
import select2 from 'select2';
import axios from 'axios';
import moment from 'moment';
import VueAxios from 'vue-axios';
import vSelect from 'vue-select';
import VeeValidate from 'vee-validate';
import VueAlertify from 'vue-alertify';
import 'vue-select/dist/vue-select.css';
import vuetify from '@/plugins/vuetify';
import ImageUploader from 'vue-image-upload-resize';
import 'select2/dist/css/select2.min.css';

window.$ = window.jQuery = $;

select2($);

window.select2Ready = Promise.resolve();

import justifiedGallery from 'justifiedGallery';
justifiedGallery($);

axios.defaults.headers.common = {
  'X-CSRF-Token': document.querySelector("meta[name='csrf-token']").getAttribute('content'),
  'Access-Control-Allow-Origin': '*',
};

Vue.use(ImageUploader);
Vue.component('AppLayout', AppLayout);
Vue.component('v-select', vSelect);
Vue.use(VeeValidate, {
  mode: 'passive',
});

VeeValidate.setMode('passive');
Vue.use(VueAxios, axios);
Vue.use(VueAlertify, {
  notifier: {
    delay: 10,
    position: 'bottom-right',
    closeButton: false,
  },
});

Vue.filter('toLongDate', function (value) {
  if (value) {
    return moment(String(value)).format('LL');
  } else {
    return '';
  }
});

Vue.filter('toReformatDay', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY');
  } else {
    return '';
  }
});

Vue.filter('toLongDateTime', function (value) {
  if (value) {
    return moment(String(value)).format('LLL');
  } else {
    return '';
  }
});

Vue.filter('toCurrency', function (value) {
  if (typeof value !== 'number') {
    return value;
  }
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
  });
  return formatter.format(value);
});

Vue.filter('toCurrencyDecimals', function (value) {
  if (typeof value !== 'number') {
    return value;
  }
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  });
  return formatter.format(value);
});

Vue.filter('toNumberFormat', function (value) {
  if (value) {
    return new Intl.NumberFormat().format(value);
  } else {
    return 0;
  }
});

Vue.filter('firstLetter', function (value) {
  if (value) {
    return value.charAt(0);
  } else {
    return '-';
  }
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initApp);
} else {
  initApp();
}

async function initApp() {
  await loadAllLocales();

  Vue.prototype.$user = new User();
  Vue.prototype.$tenantName = document.querySelector('body').dataset.tenantName;

  // Frontend Logger setup
  const isProduction = process.env.NODE_ENV === 'production';
  const loggingEnabled = import.meta.env.VITE_LOGGING_ENABLED !== 'false';
  const tenantName = document.querySelector('body').dataset.tenantName || 'public';

  const logger = new FrontendLogger({
    enabled: loggingEnabled,
    minLevel: isProduction ? 'warn' : 'debug',
    isDevelopment: !isProduction,
    store: store,
    tenant: tenantName,
  });

  Vue.use(logger);
  logger.start();

  const app = new Vue({
    router,
    store,
    i18n,
    vuetify,
    render: (h) => h(App),
  }).$mount('#app');
}
